module.exports = "/images/print-ad.svg?2beacdd8486b658a8a87118e226330b1";